import { render } from "./AdminCashCenter.vue?vue&type=template&id=2234f6ff&scoped=true&ts=true"
import script from "./AdminCashCenter.vue?vue&type=script&lang=ts"
export * from "./AdminCashCenter.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2234f6ff"]])

export default __exports__